import { ParallaxProvider } from 'react-scroll-parallax';
import ParticlesBackground from './componentes/ParticlesBackground';
import Header from './componentes/Header';
import Inicio from './componentes/Inicio';
import Servicios from './componentes/Servicios';
import Portafolio from './componentes/Portafolio';
import Contacto from './componentes/Contacto';
import Footer from './componentes/Footer';
import PorqueSitioWeb from './componentes/PorqueSitioWeb';
import SolucionesParaTodos from './componentes/SolucionesParaTodos';
import SEO from './componentes/SEO';
import img from './assets/img/logo-red-digital-text.png'
export default function App() {
  return (
    <>
    <SEO
        title="Transforma tu presencia digital"
        description="Desarrollamos páginas web impactantes, accesibles y con identidad visual para tu marca. Ya sea grande o pequeña, tu negocio merece presencia online."
        url="https://reddigitalcreations.com"
        image={img}
      />
      <ParallaxProvider>
        <ParticlesBackground />
        <Header />
        <main>
          <Inicio />
          <PorqueSitioWeb />
          <SolucionesParaTodos />
          <Servicios />
          <Portafolio />
          <Contacto />
          <Footer />
        </main>
      </ParallaxProvider>
    </>
  );
}
